import { render, staticRenderFns } from "./quizConfig.vue?vue&type=template&id=5680cac4&"
import script from "./quizConfig.vue?vue&type=script&lang=js&"
export * from "./quizConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports